import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getProjectUsers } from '../../../redux/actions';
import { Grid, IconButton, Paper, Typography } from '@mui/material';
import { IoMdSettings } from "react-icons/io";

export default function Users({ project }) {

  const dispatch = useDispatch();
  const projectUsers = useSelector(state => state.cada.projectUsers);

  useEffect(() => {
    if (projectUsers && projectUsers?.[project.id]?.length > 0) {
      return;
    }

    if (project?.id) {
      dispatch(getProjectUsers(project.id));
    }

  }, [project, dispatch]);

  const handleEditUserRole = () => {
    // TODO
  };

  return (
    <>
      {projectUsers?.[project.id]?.map((user) => (
        <Paper
          key={user.id}
          sx={{
            p: 2,
            borderRadius: 4,
            display: 'flex',
            alignItems: 'center',
            mb: 2,
          }}
        >
          <Grid container spacing={2} alignItems="center" flexDirection="row">
            <Grid item xs={5} alignItems="center">
              <Typography variant="h6">
                {user.firstName} {user.lastName}
              </Typography>
            </Grid>
            <Grid item xs={5} alignItems="center" justifyContent="flex" flexDirection="row">
              {user.cadaProjectUsers.map((pu) => (
                <Typography key={pu.id} variant="body1" color="gray">
                  {pu.role}
                </Typography>
              ))}
            </Grid>
          </Grid>
          <Grid item xs={2} alignItems="center" justifyContent="flex-end" flexDirection="row">
            <IconButton onClick={handleEditUserRole}>
              <IoMdSettings />
            </IconButton>
          </Grid>
        </Paper>
      ))}
    </>
  );
};
